<script lang="ts">
  import type { RestPanelProps } from '$lib/types/articleTypes';
  export let restDescription: RestPanelProps['restDescription'];
  export let duration: RestPanelProps['duration'];
</script>

<section class="flex flex-row justify-center mt-4 sm:mt-0 sm:mb-4 px-4 lg:px-0">
  <div
    class="flex flex-row justify-center items-center lg:items-end bg-gray-100 w-[375px] sm:w-[400px] md:w-[768px] lg:w-[800px] rounded-xl py-4 px-6 md:px-8"
  >
    <h3 class="text-gray-900 text-md sm:text-xxl font-semibold pr-4 md:pr-8">{restDescription}</h3>
    <p class="text-gray-500 text-sm sm:text-xl font-medium">{duration}</p>
  </div>
</section>
<span class="hidden sm:block sm:border-b sm:border-gray-100"></span>
